<script setup lang="ts">
interface IFilter {
  size?: string
  expanded?: boolean
}

withDefaults(defineProps<IFilter>(), {
  size: 'w-14',
  expanded: true,
})
</script>

<template>
  <div
    class="flex flex-row items-center"
    :class="expanded ? 'gap-2 justify-start' : 'gap-0 justify-center'"
  >
    <img :class="size" class="shrink-0" src="/images/logo/logo-icon.svg" alt="Logo" />
    <h1
      class="font-bold leading-4 text-logo dark:text-gray-400 text-theme-sm whitespace-nowrap overflow-hidden transition-all duration-300"
      :class="expanded ? 'max-w-40 opacity-100' : 'max-w-0 opacity-0'"
    >
      SYNTECH
      <span class="block font-normal text-xs">ERP SYSTEM</span>
    </h1>
  </div>
</template>
